import React, { useState } from 'react';
import './Faquestions.scss'
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';

const Question = ({id,title,info}) => {
const[open, setOpen] =useState(false)
  
  return (
  <>
    <div className="questionFAQ" key={id} onClick={()=>{setOpen(!open)}}>
      <header><h4   >{title}</h4> 
      <button className="btnFAQ" onClick={()=>{setOpen(!open)}}> {open? <AiOutlineMinus/> :<AiOutlinePlus/>} </button></header>
      {open && <p>{info}</p> }
    </div>
  </>
  )
};

export default Question;
